import InstagramIcon from "../assets/images/icons/instagram.svg";
import TwitterIcon from "../assets/images/icons/twitter.svg";
import SpotifyIcon from "../assets/images/icons/spotify.svg";
import YoutubeIcon from "../assets/images/icons/youtube.svg";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { sendSupportMessage } from "../redux/actions/contact";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Footer = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [topic, setTopic] = useState('')
  const [message, setMessage] = useState('')
  
  const handleSubmitMessage = (e) => {
    e.preventDefault()
    const reqBody = {
      name: firstName + ' ' + lastName,
      email: email,
      topic: topic,
      message: message 
    }
    dispatch(sendSupportMessage(toast, reqBody, setIsLoading))
    if(!isLoading){
      setFirstName('')
      setLastName('')
      setEmail('')
      setTopic('')
      setMessage('')
    }
  }

  return (
    <footer className="relative z-10 bg-gradient-to-t from-[#000456] via-[#00067E] to-[#0a1a8a] border-t border-[#1e3a8a]/30">
      <ToastContainer/>
      <div className="container mx-auto py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-16">
          <div className="space-y-6 lg:col-span-1">
            <Link to="/" className="flex items-center">
              <img
                src={require("../assets/images/logo.png")}
                alt="UpNComer"
                className="h-8 w-auto drop-shadow-lg"
              />
            </Link>
            <p className="text-[#93c5fd]/80 text-sm leading-relaxed font-light">
              Empowering independent artists with AI-powered music industry
              tools. Your music, your success, your control.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/upncomer.co/" target="_blank" rel="noopener noreferrer"><img src={InstagramIcon} alt="Instagram" className='block transition-all hover:rotate-[360deg] hover:scale-125 duration-500' /></a>
              <a href="https://x.com/upncomerco" target="_blank" rel="noopener noreferrer"><img src={TwitterIcon} alt="Twitter" className='block transition-all hover:rotate-[360deg] hover:scale-125 duration-500' /></a>
              <a href="https://open.spotify.com/user/3142hxn2i3wyimc3yj25skyerhpu?si=7a3cda9f9b574736" target="_blank" rel="noopener noreferrer"><img src={SpotifyIcon} alt="Spotify" className='block transition-all hover:rotate-[360deg] hover:scale-125 duration-500' /></a>
              <a href="https://www.youtube.com/@upncomer" target="_blank" rel="noopener noreferrer"><img src={YoutubeIcon} alt="Facebook" className='block transition-all hover:rotate-[360deg] hover:scale-125 duration-500' /></a>
              {/* {[
                {
                  icon: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z",
                },
                {
                  icon: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z",
                },
                {
                  icon: "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z",
                },
                {
                  icon: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
                },
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className="text-[#60a5fa]/60 hover:text-[#FA6138] transition-all duration-300 transform hover:scale-110"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d={social.icon} />
                  </svg>
                </a>
              ))} */}
            </div>
          </div>

          <div className="space-y-6 lg:col-span-1">
            <h3 className="text-[#93c5fd] font-semibold tracking-wide">
              Product
            </h3>
            <ul className="space-y-3 text-sm">
              {[
                { href: "/distribution", label: "Distribution" },
                { href: "/features", label: "Features" },
                { href: "/pricing", label: "Pricing" },
                { href: "/our-story", label: "Our Story" },
                // { href: "/tutorials", label: "Tutorials" },
                // { href: "/community-updates", label: "Community Updates"},
                // { href: "/help-center", label: "Help Center"},
                // { href: "/case-studies", label: "Case Studies"},
                // { href: "/blog", label: "Blog" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#60a5fa]/80 hover:text-[#93c5fd] transition-all duration-300 font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6 lg:col-span-1">
            <div>
            <h3 className="text-[#93c5fd] font-semibold tracking-wide">
              Resources
            </h3>
            <br/>
            <ul className="space-y-3 text-sm">
              {[
                { href: "/blog", label: "Blog" },
                { href: "/tutorials", label: "Tutorials" },
                // { href: "/community-updates", label: "Community Updates" },
                // { href: "/case-studies", label: "Case Studies" },
                { href: "/help-center", label: "Help Center" },
              ].map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-[#60a5fa]/80 hover:text-[#93c5fd] transition-all duration-300 font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            </div>
          </div>

          <div className="space-y-6 lg:col-span-2">
            <h3 className="text-[#93c5fd] font-semibold tracking-wide">
              Contact Us
            </h3>
            <form action="submit" className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                    placeholder="First Name"
                    className="w-full px-4 py-3 bg-[#1e3a8a]/15 border border-[#3b82f6]/20 rounded-xl text-[#93c5fd] placeholder-[#60a5fa]/60 focus:outline-none focus:ring-2 focus:ring-[#FA6138]/50 focus:border-[#FA6138]/50 transition-all text-sm backdrop-blur-xl"
                    required
                  />
                </div>
                <div>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(event) => setLastName(event.target.value)}
                    placeholder="Last Name"
                    className="w-full px-4 py-3 bg-[#1e3a8a]/15 border border-[#3b82f6]/20 rounded-xl text-[#93c5fd] placeholder-[#60a5fa]/60 focus:outline-none focus:ring-2 focus:ring-[#FA6138]/50 focus:border-[#FA6138]/50 transition-all text-sm backdrop-blur-xl"
                    required
                  />
                </div>
              </div>
              <div>
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Email Address"
                  className="w-full px-4 py-3 bg-[#1e3a8a]/15 border border-[#3b82f6]/20 rounded-xl text-[#93c5fd] placeholder-[#60a5fa]/60 focus:outline-none focus:ring-2 focus:ring-[#FA6138]/50 focus:border-[#FA6138]/50 transition-all text-sm backdrop-blur-xl"
                  required
                />
              </div>
              <div>
                <select
                  value={topic}
                  onChange={(event) => setTopic(event.target.value)}
                  className="w-full px-4 py-3 bg-theme_clr1 border border-[#3b82f6]/20 rounded-xl text-[#93c5fd] focus:outline-none focus:ring-2 focus:ring-[#FA6138]/50 focus:border-[#FA6138]/50 transition-all text-sm backdrop-blur-xl"
                  required
                >
                  <option value="" disabled>Select a topic</option>
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Request Demo">Request Demo</option>
                  <option value="Pricing Question">Pricing Questions</option>
                  <option value="Technical Support">Technical Support</option>
                  <option value="Partnership Opportunities">Partnership Opportunities</option>
                </select>
              </div>
              <div>
                <textarea
                  placeholder="Your Message"
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  rows={3}
                  className="w-full px-4 py-3 bg-[#1e3a8a]/15 border border-[#3b82f6]/20 rounded-xl text-[#93c5fd] placeholder-[#60a5fa]/60 focus:outline-none focus:ring-2 focus:ring-[#FA6138]/50 focus:border-[#FA6138]/50 transition-all resize-none text-sm backdrop-blur-xl"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                onClick={handleSubmitMessage}
                className="bg-gradient-to-r from-[#FA6138] to-[#e55532] text-white px-6 py-3 text-sm font-medium tracking-wider rounded-xl hover:from-[#e55532] hover:to-[#FA6138] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                {isLoading ? "Sending your message..." : "SEND MESSAGE"}
              </button>
            </form>
            <div className="text-xs text-[#60a5fa]/60 font-light">
              We'll get back to you within 24 hours. For urgent matters, please
              email{" "}
              <a
                href="mailto:support@upncomer.co"
                className="text-[#FA6138] hover:underline"
              >
                support@upncomer.co
              </a>
            </div>
          </div>
        </div>

        {/* Enhanced Bottom Footer */}
        <div className="border-t border-[#1e3a8a]/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-[#60a5fa]/80">
              <p>&copy; {new Date().getFullYear()} UpNComer Pte. Ltd. All rights reserved.</p>
              <div className="flex space-x-6">
                {[
                  { href: "/privacy-policy", label: "Privacy Policy" },
                  {
                    href: "/terms-of-service",
                    label: "Terms & Conditions",
                  },
                  { href: "/cookie-policy", label: "Cookie Policy" },
                ].map((link, index) => (
                  <Link
                    key={index}
                    to={link.href}
                    className="hover:text-[#93c5fd] transition-colors font-light"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className="flex items-center space-x-2 text-xs text-[#60a5fa]/60 font-light">
              <span>Made with</span>
              <span className="text-[#FA6138]">♪</span>
              <span>for independent artists</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
